<template>
    <li class="dropdown client-apps-dropdown">
        <a
            href="javascript:void(0);"
            class="btn btn-secondary dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
        >
            <i class="dripicons-browser"></i>
            <span v-text="currentSiteLabel"></span>
        </a>
        <div class="dropdown-menu">
            <a
                href="javascript: void(0)"
                class="dropdown-item"
                v-for="(item, index) in this.websites"
                :class="activeClass(index)"
                :key="item.id"
                v-text="item.name"
                @click="switchWebsite(item.id)"
            ></a>
            <template v-if="false">
                <div class="dropdown-divider"></div>
                <a
                    href="#"
                    @click.prevent="showCreateWebsiteModal()"
                    class="dropdown-item"
                >New Website...</a>
            </template>
        </div>
    </li>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { findIndex } from "lodash";

import { EventBus } from "@/utils/EventBus";

export default {
    data() {
        return {
            // websites: []
            // currentIndex: 0
        };
    },
    watch: {
        $route: {
            handler: "queryWebsites",
            immediate: true
        }
    },
    methods: {
        activeClass(index) {
            return this.currentIndex == index ? "active" : null;
        },
        switchWebsite(id) {
            // this.changeCurrentWebsite(id);
            this.$router.replace({ params: { site_id: id } });
        },
        showCreateWebsiteModal() {
            EventBus.$emit("show-modal", "create-website-modal");
        },
        ...mapMutations(["changeCurrentWebsite"]),
        ...mapActions(["queryWebsites"])
    },
    computed: {
        currentIndex() {
            return findIndex(this.websites, {
                id: parseInt(this.currentWebsiteId)
            });
        },
        currentSiteLabel() {
            // console.log(this.currentIndex);
            if (this.websites[this.currentIndex]) {
                return this.websites[this.currentIndex].name;
            }
            return null;
        },
        ...mapState(["websites", "currentWebsiteId"])
    }
};
</script>

<style lang="scss" scoped>
.client-apps-dropdown {
    .dropdown-toggle {
        display: flex;
        align-items: center;

        & > i {
            margin-right: rem-calc(5);
            line-height: 1.5;
        }

        span {
            padding: 0 rem-calc(5);
        }
    }
}
</style>